
import { EntityConfig, EntityConfigRegistry } from './types';
import { WORKBOOK_CONFIG } from './workbook-config';
import { PAGE_CONFIG } from './page-config';
import { PROJECT_CONFIG } from './project-config';
import { GOAL_CONFIG } from './goal-config';
import { CAMPAIGN_CONFIG } from './campaign-config';

/**
 * Central registry of all entity configurations
 */
export const ENTITY_CONFIGS: EntityConfigRegistry = {
  workbook: WORKBOOK_CONFIG,
  page: PAGE_CONFIG,
  project: PROJECT_CONFIG,
  goal: GOAL_CONFIG,
  campaign: CAMPAIGN_CONFIG,
};
